import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sectionActive',
  standalone: true,
  pure: true,
})
export class SectionActivePipe implements PipeTransform {
  transform(currentSection: string, match: string | string[]): boolean {
    if (!currentSection) return false;
    return Array.isArray(match)
      ? match.includes(currentSection)
      : match === currentSection;
  }
}
